import React from "react";

import { ReactComponent as IconArchived } from "../../assets/icons/status-archived.svg";
import { ReactComponent as IconCurrent } from "../../assets/icons/status-current.svg";
import { ReactComponent as IconReview } from "../../assets/icons/status-review.svg";
import { ReactComponent as IconDraft } from "../../assets/icons/status-draft.svg";
import { joinClassNames } from "../../utils/joinClassNames";

import styles from "./ResourceStatus.module.css";
import { detectCase } from "../../utils/detectCase";
import camelCaseToTitleCase from "../../utils/camelToTitleCase";

export const statusDefs = {
    archived: {
        icon: IconArchived,
        label: "Archived",
    },
    current: {
        icon: IconCurrent,
        label: "Current",
    },
    reviewInProgress: {
        icon: IconReview,
        label: "Review in Progress",
    },
    draft: {
        icon: IconDraft,
        label: "Draft",
    },
};

export type StatusValues =
    | "archived"
    | "current"
    | "reviewInProgress"
    | "draft";

export type ResourceStatusProps = {
    status?: StatusValues;
    className?: string;
};

const maybeConvertStatus = (status: StatusValues | undefined): string => {
    if (!status) return "";
    if (detectCase(status) === "camelcase") {
        return camelCaseToTitleCase(status);
    }
    return status;
};

export const ResourceStatus = ({
    status,
    className = "",
}: ResourceStatusProps) => {
    const statusDef = status ? statusDefs[status] : "";
    const { icon, label } = statusDef || { label: maybeConvertStatus(status) };

    /*
     * This will never print a div,
     * but it still needs a valid tag
     * to make TypeScript happy.
     */
    const Icon = icon ? icon : "div";
    const maybeIcon = icon ? <Icon className={styles.icon} /> : null;
    return (
        <span className={joinClassNames([styles.status, className])}>
            {maybeIcon}
            <span className={styles.label}>{label}</span>
        </span>
    );
};

export default ResourceStatus;
